export const AiSuggestionChip = {
  tag: 'button',
  text: (el, s) => s.label,
  fontSize: 'Y',
  fontWeight: '500',
  padding: 'Y Z',
  round: 'B',
  background: 'purple.1',
  border: '1px solid purple.3',
  color: 'purple',
  cursor: 'pointer'
}
